import { render, staticRenderFns } from "./PrintSoTienMat.vue?vue&type=template&id=317768e4"
import script from "./PrintSoTienMat.vue?vue&type=script&lang=js"
export * from "./PrintSoTienMat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports